// extracted by mini-css-extract-plugin
module.exports = {"error":"_8377252a mw7 center"};